module.exports = __webpack_public_path__ + "media/images/home/application_image-29de9824d3ef228c0f8dfc07e7b1156c.png";